import React, { useState } from "react";
import {
  Menu as MenuIcon,
  Search,
  ArrowDropDownOutlined,
  Settings,
  LogoutOutlined,
} from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import {
  AppBar,
  Button,
  Box,
  Typography,
  IconButton,
  InputBase,
  Toolbar,
  Menu,
  MenuItem,
  useTheme,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/authSlice";
import { useSelector } from 'react-redux';
import { clearUser } from '../state/index';
import { ChatIconBadge } from "../components/ChatBadge";

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const user = useSelector((state) => state.global.user);
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleLogout = () => {
    handleClose();
    localStorage.removeItem('user');
    dispatch(logout());
    dispatch(clearUser());
    navigate("/login");
  };

  const displayUsername = user?.displayName ? user.displayName : "Loading...";

  const userProfileImage = user?.photoURL ? 
   `${user.photoURL}` : 
   "../assets/profile.jpeg";
  
  const navigateToSettings = () => {
    navigate('/settings');
  };

  const navigateToChat = () => {
    navigate('/chat');
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (searchTerm) {
      navigate('/results', { state: { searchTerm } });
      setSearchTerm('');
    }
};
  
  return (
    <AppBar
      sx={{
        position: "static",
        background: "none",
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT SIDE */}
        <FlexBetween>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton>
          <Paper component="form" onSubmit={handleSubmit}>
            <FlexBetween
              backgroundColor={theme.palette.background.alt}
            >
              <InputBase
                placeholder=" Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{pl:1}}
              />
              <IconButton type="submit">
                <Search />
              </IconButton>
            </FlexBetween>
          </Paper>
          
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween>
        <IconButton onClick={navigateToChat} sx={{mr: {xs:"0.5rem", lg: "1rem" }}}>
            <ChatIconBadge/>
      </IconButton>

          <FlexBetween>
            <Button
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: {xs:"0" ,lg:"1rem"},
              }}
            >
              <Box
                component="img"
                alt="profilePic"
                src={userProfileImage}
                height="40px"
                width="40px"
                borderRadius="50%"
                sx={{ objectFit: "cover" }}
              />
              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{
                    display: {xs: "none", lg: "block"},
                    color: theme.palette.secondary[100]
                  }}
                >
                  {displayUsername}
                </Typography>
                
              </Box>
              <ArrowDropDownOutlined
                sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <MenuItem onClick={navigateToSettings}><Settings sx={{mr:1}} /> Settings</MenuItem>
              <MenuItem onClick={handleLogout}><LogoutOutlined sx={{mr:1}} /> Log Out</MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
